type RichTextManifestSourceData = Record<string, [string, number]>;

const richTextManifestSourceData: RichTextManifestSourceData = {
  '[Aim Down Sights]': ['SandboxPerk', 2169611095],
  '[Alternate Weapon Action]': ['SandboxPerk', 250262009],
  '[Arc]': ['Objective', 85535852],
  '[Auto Rifle]': ['Objective', 60057218],
  '[Block]': ['SandboxPerk', 2236497009],
  '[Boost]': ['SandboxPerk', 3104860955],
  '[Bow]': ['Objective', 817189956],
  '[Brake]': ['SandboxPerk', 4189070124],
  '[Currency]': ['Objective', 5982754],
  '[Disruption]': ['SandboxPerk', 669536781],
  '[Fusion Rifle]': ['Objective', 579143207],
  '[Grenade Launcher]': ['Objective', 43313268],
  '[Grenade]': ['Objective', 45245118],
  '[Hand Cannon]': ['Objective', 671993070],
  '[Headshot]': ['Objective', 116015535],
  '[Heavy Attack]': ['SandboxPerk', 971817906],
  '[Insert Medal Here]': ['Objective', 2254471463],
  '[Kill]': ['Objective', 114960131],
  '[Large Blocker]': ['Objective', 2031240843],
  '[Light Attack]': ['SandboxPerk', 355406666],
  '[Linear Fusion Rifle]': ['Objective', 781144469],
  '[Lost Sector]': ['Objective', 2047785576],
  '[Machine Gun]': ['Objective', 781144468],
  '[Medium Blocker]': ['Objective', 3792840449],
  '[Melee]': ['Objective', 44811435],
  '[Pulse Rifle]': ['Objective', 189060104],
  '[Quest]': ['Objective', 119206183],
  '[Rocket Launcher]': ['Objective', 13215836],
  '[SMG]': ['Objective', 102976778],
  '[Scout Rifle]': ['Objective', 75057024],
  '[Shield-Piercing]': ['SandboxPerk', 1427016431],
  '[Shoot]': ['SandboxPerk', 2805448568],
  '[Shotgun]': ['Objective', 145168517],
  '[Sidearm]': ['Objective', 139630754],
  '[Small Blocker]': ['Objective', 276438067],
  '[Sniper Rifle]': ['Objective', 55815981],
  '[Solar]': ['Objective', 85535853],
  '[Stagger]': ['SandboxPerk', 72139184],
  '[Stasis: Glyph 0]': ['Objective', 1397002441],
  '[Stasis: Glyph 1 Locked]': ['Objective', 1851419582],
  '[Stasis: Glyph 2 Locked]': ['Objective', 1857129539],
  '[Stasis: Glyph 3 Locked]': ['Objective', 1481711502],
  '[Stasis]': ['Objective', 85761957],
  '[Super]': ['SandboxPerk', 3368836162],
  '[Sword]': ['Objective', 1260068656],
  '[Trace Rifle]': ['Objective', 704693244],
  '[Void]': ['Objective', 33657378],
  '': ['Objective', 4231452845],
  '': ['Objective', 1408767523],
};

export default richTextManifestSourceData;
